// import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './style/scrool.css';
import './style/thim-ekits-icons.min.css';

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import PaymentResult from "./pages/PaymentResult";
import Loading from "./pages/Loading";
import Consultation from "./pages/Consultation";
import AgentRequest from "./pages/AgentRequest";
import Service from "./pages/Service";


const App = () => {

  return (

    <div className='overflow-hidden'>

      <ToastContainer style={{position: 'fixed', zIndex: 10000}} rtl/>
      <Router>
        <Routes>
          <Route path="/" element={<Home/>}/>
          {/*<Route path="/product/:id" element={<ProductDetails/>}/>*/}
          <Route path="/login" element={<Login/>}/>
          <Route path="/register" element={<Register/>}/>
          <Route path="/forgot_password" element={<ForgotPassword/>}/>
          <Route path="/payment_result" element={<PaymentResult/>}/>
          <Route path="/loading" element={<Loading/>}/>
          <Route path="/timesheet.html?" element={<Consultation/>}/>
          <Route path="/service-reserve.html?" element={<Service/>}/>
          <Route path="/register_agent" element={<AgentRequest/>}/>
          {/*<Route path="/resetPassword" element={<ResetPassword/>}/>*/}
          {/*<Route path="/profile" element={<Profile />}/>*/}
          {/*<Route path="/shop" element={<ShopHome />}/>*/}
        </Routes>
      </Router>

    </div>
  );
};

export default App;
